declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, IvfCycleMembersListController, IvfCycleMembersListRequest, CounsellingPlanController, CounsellingPlanRequest, FormOrganizer, EditTreatmentCycleStatusRequest, GenericProcPostRequest, S_Methods } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { NgbEggStorageModal } from './eggstorage.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'treatmentCycle2',
  templateUrl: './treatmentCycle2.component.html',
  styleUrls: ['./treatmentCycle2.component.scss'],
  animations: [routerTransition()]
})

export class TreatmentCycle2Component implements OnInit, AfterViewInit {
    @Output() GoBack: EventEmitter<any> = new EventEmitter();
  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;
    OnGoFollicle() {
        this.LoadCycles();
    }
  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;

  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
    @Input() Duration: number;
    @Input() ActorCodeProfile: any;
    @Input() CycleCodeProfile: any;
    @Input() DurationProfile: any;
    @Input() FormattedCode: string;
    @Input() titleapp: any;
    @Input() DisplayName: string;
    @Input() GradingModel: string;
    @Input() GradingModelProfile: any;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
    public Code: string;
    public RefreshData: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;
  public LMPDate: Date;
  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  //


  CurrentFdActorReportsDocController: FdActorReportsDocController[];
  CurrentFDActorDocRequest: FDActorDocRequest;

  LoadForms() {
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFdActorReportsDocController();
  }
  public SelectedReport: string;
  public SelectedActorCode: number;
  GetFdActorReportsDocController() {
    this.StartRefreshing();

      this.CurrentFDActorDocRequest.ActorCode = this.SelectedActorCode;
    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentFDActorDocRequest.ConditionalOperator = 11;
    //alert(this.FormattedCode);
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
            this.LMPDate = this.SelectedTreatmentCycle.LMP;

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
            this.stopRefreshing();
            this.LoadPlans();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
    }
    CurrentCounsellingPlanController: CounsellingPlanController[];
    CurrentCounsellingPlanRequest: CounsellingPlanRequest;
   
    LoadPlans() {

        this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
        this.CurrentCounsellingPlanRequest.ActorCode = this.ActorCode.toString();
        this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;

        //alert(this.ActorCode);
        this.CurrentCounsellingPlanRequest.ConditionalOperator = 20;
        this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetCounsellingPlanController();
    }
    //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
    GetCounsellingPlanController() {
        this.StartRefreshing();
        //alert("LOading guarding adata");
        //alert(this.CurrentGuardianInfoRequest.ActorCode);

        this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentCounsellingPlanController = this.ApiResData.Result;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

                    //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
                    this.stopRefreshing();
                 

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //LoadPlans() {

    //}

  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  FollicularData: TreatmentCycleStatusController[];
  FollicularData2: TreatmentCycleStatusController;
  PickupData: TreatmentCycleStatusController[];
  PickupData2: TreatmentCycleStatusController;
  OocyteData: TreatmentCycleStatusController[];
  OocyteData2: TreatmentCycleStatusController;
  InseminationData: TreatmentCycleStatusController[];
  InseminationData2: TreatmentCycleStatusController;
  EmbryoTransferData: TreatmentCycleStatusController[];
  EmbryoTransferData2: TreatmentCycleStatusController;
  SemanAnalysis: TreatmentCycleStatusController[];
    SemanAnalysis2: TreatmentCycleStatusController;
    EmbryoGradingData: TreatmentCycleStatusController[];
    EmbryoGradingData2: TreatmentCycleStatusController;

  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        //alert("Treatmentcycle");
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.FollicularData = this.ApiResData.Result;
          this.PickupData = this.ApiResData.Result;
          this.OocyteData = this.ApiResData.Result;
          this.SemanAnalysis = this.ApiResData.Result;
          this.InseminationData = this.ApiResData.Result;
            this.EmbryoTransferData = this.ApiResData.Result;
            this.EmbryoGradingData = this.ApiResData.Result;
          var Follicularlist = this.FollicularData.filter(
            function (b) {
              return b.PhaseActivity == "Follicular Scans";
            });
          this.FollicularData = Follicularlist;
          this.FollicularData2 = this.FollicularData[0];
          //alert(this.FollicularData[0].PhaseActivity);

          var Pickuplist = this.PickupData.filter(
            function (c) {
              return c.PhaseActivity == "Pickup";
            });
          this.PickupData = Pickuplist;
          this.PickupData2 = this.PickupData[0];
          //alert(this.PickupData[0].PhaseActivity);
          var Oocytelist = this.OocyteData.filter(
            function (e) {
              return e.PhaseActivity == "Oocyte Assessment";
            });
          this.OocyteData = Oocytelist;
          this.OocyteData2 = this.OocyteData[0];
          //alert(this.OocyteData[0].PhaseActivity);
          var Semanlist = this.SemanAnalysis.filter(
            function (a) {
              return a.PhaseActivity == "Semen Analysis";
            });
          this.SemanAnalysis = Semanlist;
          this.SemanAnalysis2 = this.SemanAnalysis[0];
          //alert(this.SemanAnalysis[0].PhaseActivity);
          var Inseminationlist = this.InseminationData.filter(
            function (g) {
              return g.PhaseActivity == "Insemination";
            });
          this.InseminationData = Inseminationlist;
          this.InseminationData2 = this.InseminationData[0];
          var embryotransferlist = this.EmbryoTransferData.filter(
            function (g) {
              return g.PhaseActivity == "Embryo Transfer";
            });
          this.EmbryoTransferData = embryotransferlist;
            this.EmbryoTransferData2 = this.EmbryoTransferData[0];
            var EmbryoGradinglist = this.EmbryoGradingData.filter(
                function (g) {
                    return g.PhaseActivity == "Embryo Grading";
                });
            this.EmbryoGradingData = EmbryoGradinglist;
            this.EmbryoGradingData2 = this.EmbryoGradingData[0];
          //var Follicularlist = this.FollicularData.filter(
          //     function (b) {
          //        return b.PhaseActivity == "Follicular Scans";
          //    });
          //this.FollicularData = this.Follicularlist;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
            this.Loadmembers();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
    }
    CurrentIvfCycleMembersListController: IvfCycleMembersListController[];
    CurrentIvfCycleMembersListRequest: IvfCycleMembersListRequest;
    Loadmembers() {
        this.CurrentIvfCycleMembersListRequest = new IvfCycleMembersListRequest();
        this.CurrentIvfCycleMembersListRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleMembersListRequest.ConditionalOperator = 10;
        this.CurrentIvfCycleMembersListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleMembersListController();
    }
    GetIvfCycleMembersListController() {
        this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

        this.actorservice.GetIvfCycleMembersListController(this.CurrentIvfCycleMembersListRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfCycleMembersListController = this.ApiResData.Result;
                   
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  //CurrentIvfTreatmentPlanController: IvfTreatmentPlanController[];
  //PlanDetails: IvfTreatmentPlanController;
  //CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
  //LoadPlan() {
  //  this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
  //  this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.CurrentIvfTreatmentPlanRequest.CycleCode = this.CycleCode;
  //  this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
  //  this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


  //  this.GetIvfTreatmentPlanController();
  //}
  //GetIvfTreatmentPlanController() {
  //  this.StartRefreshing();


  //  this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {
  //        this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
  //        this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];

  //        this.stopRefreshing();
  //        this.LoadActivities();
  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  //CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController;
  //CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  //LoadActivities() {
  //  this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
  //  this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = this.PlanDetails.FollowupPlanCode;

  //  this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 30;
  //  this.CurrentCounsellingActivitiesByTimeRequest.FromDate = new Date();
  //  this.CurrentCounsellingActivitiesByTimeRequest.ToDate = new Date();

  //  this.CurrentCounsellingActivitiesByTimeRequest.SearchText = "";
  //  this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetCounsellingActivitiesByTimeController();
  //}
  //GetCounsellingActivitiesByTimeController() {
  //  this.StartRefreshing();
  //  //this.spinner.show();

  //  this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;

  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
      private modalService: NgbModal, private spinner: NgxSpinnerService) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {
      this.SelectedActorCode = this.ActorCode;
      
      this.titleapp = this.route.snapshot.paramMap.get('title');

      if (this.titleapp == "Profile") {
          this.ActorCodeProfile = this.route.snapshot.paramMap.get('ActorCode');
          this.CycleCodeProfile = this.route.snapshot.paramMap.get('CycleCode');
          this.DurationProfile = this.route.snapshot.paramMap.get('Duration');
          this.GradingModelProfile = this.route.snapshot.paramMap.get('GradingModel');
          this.ActorCode = this.ActorCodeProfile;
          this.CycleCode = this.CycleCodeProfile;
          this.GradingModel = this.GradingModelProfile;
          this.Duration = this.DurationProfile;
          this.SelectedActorCode = this.ActorCode;
      }
     // this.Duration = this.route.snapshot.paramMap.get('Duration');
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
      ///////////////////////
      //window.opener;
      this.LoadForms();
    this.LoadCycles();


      //this.
    //this.LoadPlan();
    //this.LoadActivities();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;


    this.onSetFeatureAccessConfig();

    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



    }
    public viewmode: string = 'view';
    public fo: FormOrganizer;

    SetForm() {

        this.fo = new FormOrganizer();

        this.fo.Sections = new Array<SectionData>();
        var i = 0;
        while (i < this.FormData.length) {
            this.fo.Sections.push(this.FormData[i]);
            i++;
        }
        this.fo.Organize();
        this.spinner.hide();
    }

  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
    LoadClinics(reportCode: string) {
        this.spinner.show();
    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
            this.FormData = this.ApiResData.Result;
            this.SetForm();
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
    BackToProfile2() {
        this.router.navigate(['healins/profileview', { FormattedCode: this.CurrentTreatmentCyclesByActorCodeController[0].OwnerFormattedCode, DisplayName: this.CurrentTreatmentCyclesByActorCodeController[0].OwnerName, title: "cycle" }]);
  }
  EditStatus(l) {
    swal({
      title: 'Please Confirm',
      text: "You won't be able to revert Activity Status after this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.EditCycleStatus(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  EditCycleStatus(l) {
    var saveReq = new EditTreatmentCycleStatusRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40430;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ActivityName = l.PhaseActivity;
    saveReq.CycleCode = l.TreatmentCycleCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40430;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadCycles();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }
  //var PatientActorCode = this.ActorCode;


  AddDetails() {
    const modalRef = this.modalService.open(NgbTcDetailsModal,
      {
        centered: true,
        size: "lg",
        keyboard: false,
        backdrop: 'static'
      })
    //modalRef.componentInstance.ServiceCode = this.ServiceCode;
    //modalRef.result.then(x => { this.GetConsultantMap() })
  }
  //AddEventDetails() {
  //  const modalRef = this.modalService.open(NgbEventAddModal,
  //    {
  //      centered: true,
  //      size: "lg"

  //    })
  //  modalRef.componentInstance.ActorCodeNew = this.ActorCode;
  //  modalRef.componentInstance.CycleCode = this.CycleCode;
  //  modalRef.componentInstance.Plancode = this.PlanDetails.FollowupPlanCode;


  //}
  pdata: any[];// = this.data;
  listFilter: string;
  criteriaChange(value: any) {

  }
  //

  //

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    //alert("Thistrearment");
      this.GoBack.emit();
      //this.router.navigate(['healins/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InseminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
    }
    Freeze() {
        let m = document.querySelector("#Freeze");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    Top() {
        let m = document.querySelector("#top");
        if (m) {
            m.scrollIntoView({ block: "center", inline: "nearest" });
        }
    }
    

  Goto(l: TreatmentCycleStatusController) {
    if (l.PhaseActivity == "Follicular Scans") {
      this.scans();

    }
    if (l.PhaseActivity == "Pickup") {
      this.pickUp();
    }
    if (l.PhaseActivity == "Oocyte Assessment") {
      this.OQA();
    }
    if (l.PhaseActivity == "Semen Analysis") {
      this.onClick();
    }
    if (l.PhaseActivity == "Insemination") {
      this.InseminationLog();
    }
    if (l.PhaseActivity == "Embryo Grading") {
      this.Grading();
    }
    if (l.PhaseActivity == "Embryo Transfer") {
      this.ET();
      }
      if (l.PhaseActivity == "Freezing") {
          this.Freeze();
      }

    }
   
    openstorage() {
        const modalRef = this.modalService.open(NgbEggStorageModal,
            {
              centered: true,
              size: 'lg',
              keyboard: false,
              backdrop: 'static'

            })
        modalRef.componentInstance.ActorCode = this.ActorCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.GradingModel = this.GradingModel;
    }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
    RefreshAll() {
        this.LoadCycles();
        this.RefreshData = "Load";
    }

}
